/* eslint-disable no-useless-computed-key */
import { useState, useRef, useEffect } from "react";
import { Modal } from "antd";
import { research } from "../../assets/text/research";

const ResearchDetail = ({ toggle, width, height }) => {
  const [ismodalVisible, setIsModalVisible] = useState(false);
  const [modalImage, setModalImage] = useState();

  const researchNamesRef = useRef(null);
  const researchDescRef = useRef(null);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (width > 1124) {
      const offsetTop = window.getComputedStyle(researchNamesRef.current)[
        "height"
      ];
      researchDescRef.current.style.height = `calc(${
        height - 129
      }px - ${offsetTop})`;
    }
  }, [researchNamesRef, researchDescRef, width, height]);

  return (
    <div className="research-detail">
      <div className="research-detail-names" ref={researchNamesRef}>
        <div
          className="research-detail-names-english"
          style={{
            ["--hideEnglish"]: !toggle ? "none" : "block",
          }}
        >
          <div className="research-detail-names-english-title">research</div>
          <div className="research-detail-names-english-subtitle">
            BISCRIPTAL ARABIC / LATIN BOOK STRUCTURES
          </div>
          <div className="research-detail-names-english-date">
            by yara khoury nammour / january 2022
          </div>
        </div>
        <div
          className="research-detail-names-arabic"
          style={{
            ["--showArabic"]: !toggle ? "block" : "none",
          }}
        >
          <span className="research-detail-names-arabic-title">بحــــث</span>
          <p className="research-detail-names-arabic-subtitle">
            هياكل كتب ثنائية الكتابة: العربي / اللاتيني
          </p>
          <p className="research-detail-names-arabic-date">
            بقلـــم يـــارا خـــوري نـــمور / يـــناير ٢٠٢٢{" "}
          </p>
        </div>
      </div>
      <div className="research-detail-description" ref={researchDescRef}>
        <div
          className="research-detail-description-english"
          style={{
            ["--hideEnglish"]: !toggle ? "none" : "block",
          }}
        >
          {research.english.text.map((text, textIndex) => {
            let parts = text.split(/\*\*/g);
            return (
              <div className="research-detail-description-break">
                {parts.map((part, partIndex) => {
                  if (partIndex % 2 === 0 && part) {
                    return <span key={partIndex}>{part}</span>;
                  } else if (part) {
                    return (
                      <span
                        className="research-detail-description-english-bold"
                        key={partIndex}
                      >
                        {part}
                      </span>
                    );
                  }
                })}
              </div>
            );
          })}
          <hr style={{ border: "1px solid #ff0000" }} />
          <div className="research-detail-description-english-below-text">
            {research.english.footer.map((text, textIndex) => {
              let parts = text.split(/\*\*/g);
              return (
                <div style={{ marginBottom: "5%" }}>
                  {parts.map((part, partIndex) => {
                    if (partIndex % 2 === 0 && part) {
                      return (
                        <span key={partIndex}>
                          {part}
                          <br />
                          <br />
                        </span>
                      );
                    } else if (part) {
                      return (
                        <span key={partIndex}>
                          {part}
                          <br />
                          <br />
                        </span>
                      );
                    }
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div className="research-detail-description-wrapper">
          {research.images.map((image, imageIndex) => {
            return (
              <div
                className="research-detail-description-wrapper-images hide-on-mobile-screen"
                style={{ marginBottom: "8%" }}
              >
                <div className="research-detail-description-wrapper-images-image">
                  <div
                    style={{ padding: "2px 6px" }}
                    className="hide-on-mobile-screen"
                  >
                    <span style={{ fontFamily: "Decima Mono Pro" }}>
                      {image.sourceEng}
                    </span>
                    &emsp;
                    <span style={{ fontFamily: "IBM Plex Sans Arabic" }}>
                      {image.sourceArab}
                    </span>
                  </div>
                  <img
                    src={`images/${image.file}`}
                    style={{
                      // height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    alt="Research Book"
                    onClick={() => {
                      showModal();
                      setModalImage(`images/${image.file}`);
                    }}
                  ></img>
                  <div className="research-detail-description-wrapper-images-image-icons">
                    <img
                      src="/icons/resize_left.svg"
                      alt="Resize Left"
                      style={{ padding: "2px" }}
                      className="research-detail-description-wrapper-resizeicon"
                      onClick={() => {
                        showModal();
                        setModalImage(`/images/${image.file}`);
                      }}
                    />
                    <img
                      src="/icons/resize_right.svg"
                      alt="Resize Right"
                      style={{ padding: "2px" }}
                      className="research-detail-description-wrapper-resizeicon"
                      onClick={() => {
                        showModal();
                        setModalImage(`/images/${image.file}`);
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div
          className="research-detail-description-arabic"
          style={{
            ["--showArabic"]: !toggle ? "block" : "none",
          }}
        >
          {research.arabic.text.map((text, textIndex) => {
            let parts = text.split(/\*\*/g);
            return (
              <div className="research-detail-description-break">
                {parts.map((part, partIndex) => {
                  if (partIndex % 2 === 0 && part) {
                    return <span key={partIndex}>{part}</span>;
                  } else if (part) {
                    return (
                      <span
                        className="research-detail-description-arabic-bold"
                        key={partIndex}
                      >
                        {part}
                      </span>
                    );
                  }
                })}
              </div>
            );
          })}
          <hr
            style={{ border: "1px solid #ff0000" }}
            // className="hide-on-mobile-screen"
          />
          <div className="research-detail-description-arabic-below-text">
            {research.arabic.footer.map((text, textIndex) => {
              let parts = text.split(/\*\*/g);
              return (
                <div style={{ marginBottom: "5%" }}>
                  {parts.map((part, partIndex) => {
                    if (partIndex % 2 === 0 && part) {
                      return (
                        <span key={partIndex}>
                          {part}
                          <br />
                          <br />
                        </span>
                      );
                    } else if (part) {
                      return (
                        <span key={partIndex}>
                          {part}
                          <br />
                          <br />
                        </span>
                      );
                    }
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div className="research-detail-description-wrapper for-mobile-screen">
          <div className="research-detail-description-wrapper-images ">
            {research.images.map((image, imageIndex) => {
              return (
                <div className="research-detail-description-wrapper-images-image">
                  <div
                    style={{ padding: "2px 6px" }}
                    className="hide-on-mobile-screen"
                  >
                    <span style={{ fontFamily: "Decima Mono Pro" }}>
                      {image.sourceEng}
                    </span>
                    &emsp;
                    <span style={{ fontFamily: "IBM Plex Sans Arabic" }}>
                      {image.sourceArab}
                    </span>
                  </div>
                  <img
                    src={`images/${image.file}`}
                    className="research-mobile-images"
                    alt="Research Newspaper"
                  ></img>
                  <span
                    style={{
                      fontFamily: "IBM Plex Sans Arabic",
                      textAlign: "end",
                      display: toggle ? "none" : "block",
                    }}
                    className="for-mobile-screen"
                  >
                    {image.sourceArab}
                  </span>
                  <span
                    style={{
                      fontFamily: "Decima Mono Pro",
                      display: toggle ? "block" : "none",
                    }}
                    className="for-mobile-screen"
                  >
                    {image.sourceEng}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <Modal
        wrapClassName={"research-popup-modal"}
        centered
        visible={ismodalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"40%"}
      >
        <div>
          <img
            src={modalImage}
            alt="Research Book"
            style={{ width: "100%" }}
          ></img>
        </div>
      </Modal>
    </div>
  );
};

export default ResearchDetail;
